import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './shared/Logo';

const RouteUnauthorized = () => (
  <div className="gloabal-wrapper app-intro">
    <header className="main-header">
      <Logo />
      <nav>
        <ul>
          <li className="user-box">
            <Link to="/" target="_self" title="Home" className="button">Home</Link>
          </li>
        </ul>
      </nav>
    </header>
    <main className="main-wrapper">
      <section>
        <div>
          <h1>Unauthorized</h1>
          <h3>Please verify you have access and try again.</h3>
        </div>
      </section>
    </main>
  </div>
);

export default RouteUnauthorized;



// WEBPACK FOOTER //
// ./src/components/RouteUnauthorized.js